import * as Sentry from "@sentry/react";
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.css';
import { ThemeProvider } from '@mui/material';
import { theme } from './styles/globalStyles';
import { RecoilRoot } from 'recoil';

Sentry.init({
  dsn: "https://33cc4ead802796b6a4c2aba6e5cf2a70@o4507288314314752.ingest.de.sentry.io/4510311598391376",
  sendDefaultPii: true
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <RecoilRoot>
                <App />
            </RecoilRoot>
        </ThemeProvider>
    </React.StrictMode>,
);

window.addEventListener('load', async () => {
    if ('serviceWorker' in navigator) {
        try {
            await navigator.serviceWorker.register('/service-worker.js');
        } catch (e) {
            console.error(e);
        }
    }
});
